import angular from 'angular';
import { ssDialogService, vmDataService } from 'app/services';
import { alerts, confirmDialog } from 'app/components/global';

class completeControlReviewWithNoControlsDialogService {
  constructor($ssDialogService, $confirmDialog, $vmDataService, $alerts) {
    this.ssDialogService = $ssDialogService;
    this.confirmDialog = $confirmDialog;
    this.vmDataService = $vmDataService;
    this.alerts = $alerts;
  }

  show($event, product, vendor, selectRiskControlsForReviewDialog, riskControlReviewTaskId, rootScopeInstance) {
    this.product = product;
    this.vendor = vendor;
    this.selectRiskControlsForReviewDialog = selectRiskControlsForReviewDialog;
    this.riskControlReviewTaskId = riskControlReviewTaskId;
    this.rootScopeInstance = rootScopeInstance;

    this.ssDialogService.dialogs.vendorManagement.completeControlReviewWithNoControlsDialog =
      this.ssDialogService.alert(
        this.confirmDialog.getOptions($event, {
          dialogTitle: 'Complete Control Review with no Controls?',
          message:
            'You are attempting to complete a Controls Review without selecting any controls. ' +
            "This action will update only the product's Last Controls Review Date. The Residual Risk Score will remain the same as the Inherent Risk Score. " +
            'Do you want to continue?',
          handleYesClick: () => this._handleConfirmProceedWithControlReview(),
          handleNoClick: () => this._handleCancelControlReview($event),
        }),
      );
    return this.ssDialogService.show(
      this.ssDialogService.dialogs.vendorManagement.completeControlReviewWithNoControlsDialog,
    );
  }

  _handleConfirmProceedWithControlReview() {
    const { product } = this;

    this.vmDataService.updateProductLastReviewDate(product.productId).then(response => {
      const lastReviewDate = response.data;

      if (lastReviewDate !== null) {
        product.lastReviewDate = lastReviewDate;
        product.hasActiveControlReview = false;
        product.residualRisk = product.inherentRiskScore;
        product.residualRiskDisplayScore = product.inherentRiskDisplayScore;
        this.alerts.success(`The Control Review Date for "${product.name}" has been successfully updated.`);
        this.rootScopeInstance.$broadcast('refreshVMVendor', { vendorId: product.vendorId });
        this.rootScopeInstance.$rootScope.$broadcast('refreshNotifications');
      } else {
        this.alerts.error(`An error occurred attempting to updtate the Control Review Date for "${product.name}".`);
      }
    });

    this._closeCompleteControlReviewWithNoControlsDialog();
  }

  _handleCancelControlReview($event) {
    this._closeCompleteControlReviewWithNoControlsDialog();
    this._showSelectRiskControlsForReviewDialog($event);
  }

  _closeCompleteControlReviewWithNoControlsDialog() {
    return this.ssDialogService.hide(
      this.ssDialogService.dialogs.vendorManagement.completeControlReviewWithNoControlsDialog,
    );
  }

  _showSelectRiskControlsForReviewDialog($event) {
    this.ssDialogService.dialogs.vendorManagement.selectRiskControlsForReviewDialog = this.ssDialogService.alert(
      this.selectRiskControlsForReviewDialog.getOptions($event, {
        riskControlReviewTaskId: this.riskControlReviewTaskId,
        product: this.product,
        vendor: this.vendor,
      }),
    );
    return this.ssDialogService.show(this.ssDialogService.dialogs.vendorManagement.selectRiskControlsForReviewDialog);
  }
}

completeControlReviewWithNoControlsDialogService.$inject = [
  'ssDialogService',
  'confirmDialog',
  'vmDataService',
  'alerts',
];

export default angular
  .module('app.components.advisory.vendorManagement.completeControlReviewWithNoControlsDialog', [
    alerts,
    confirmDialog,
    ssDialogService,
    vmDataService,
  ])
  .service('completeControlReviewWithNoControlsDialog', completeControlReviewWithNoControlsDialogService).name;
